import api from "../../index";

export const GetAllKYCRulesApi = (params) => api.get(`UserAddKyc/GetAll-KYCRule?${params}`);
export const AddRuleApi = (data) => api.post('UserAddKyc/Add-Update-KYCRule', data);
export const UpdateRuleStatusApi = (data) => api.put('UserAddKyc/KYC-RuleOffOn', data);
export const GetUsersApi = (params) => api.get(`DropDown/GetUser-List?${params}`);
export const DeleteRuleApi = (KYCRuleId) => api.delete(`UserAddKyc/Delete-KYCRule/${KYCRuleId}`)